// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1xehr","footer":"ModalInfo_footer__nv2SA"};